import ActionModel from '../models/ActionModel.js'
import {getColoredUseLine, getColoredNameById} from '../../helpers/rollout-message-text-helpers.js'

const SuperActionModel = {
  ...ActionModel,
  isSuper: true,
  canMiss: false, //It's a little unfair that these could miss
  increaseDangerMeterOnUse: 0,

  category: "offense" //TODO!!!
};

export default {

  //Team Mega ForEach
  "special_team-foreach": {
    ...SuperActionModel,
    name: "Team ForEach",
    targetType: "opponent-team",
    description: "Delivers many iterations of pain to the opponent team.",
    affectTargetHpPointsInRepetitions: {min: 5, max: 7, affectTargetHpPoints: -5},
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      //const targetModel = targetModels[0];
      //const count = descriptionObject.description.targetsDamageTracker[targetModel.id].length;
      //console.log(descriptionObject)
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),

        {
          type: "animation",
          animationKey: "AnimationTeamForEach",
          animationData: {
            casterId: casterModel.id,
            targetIds: targetModels.map(t => t.id),
            targetsDamageTracker: descriptionObject.description.targetsDamageTracker
          },
        },

        //TODO: intense messaging
      ]
    },
  },

  //Team Slice (super)
  "special_team-slice": {
    ...SuperActionModel,
    name: "Team Slice",
    targetType: "opponent-team",
    description: "Strikes and lowers defense of entire opponent team.",
    affectTargetHpPoints: -11,
    affectTargetDefenseModifier: {percentChance: 100, value: -3},
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        {
          type: "animation",
          animationKey: "AnimationSlice",
          animationData: {
            casterId: casterModel.id,
            targetIds: targetModels.map(t => t.id)
          },
        },
        { //Play the state change!
          type: "stateChange",
          newCombatantState: descriptionObject.state,
          description: descriptionObject.description || {}
        },
        {
          type: "message",
          content: [
            `Enemy team defense lowered!`,
          ]
        }
      ]
    },
  },

  //Team Clean
  "special_team-clean": {
    ...SuperActionModel,
    name: "Team Clean",
    category: "healing",
    description: "Return all ally statuses back to normal.",
    targetType: "ally-team",
    affectTargetStatus: ["*", "normal"],
    canBeReplaced: false,

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        {
          type: "message",
          content: [
            `All ally statuses are cleared!`,
          ]
        }
      ]
    },
  },

  //Wildfire
  "special_wildfire": {
    ...SuperActionModel,
    name: "Wildfire",
    description: "Scorch the enemy team with a wall of flames.",
    targetType: "opponent-team",
    affectTargetStatus: ["*", "fire"],

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        {
          type: "message",
          content: [
            `The whole team caught fire!`,
          ]
        }
      ]
    }
  },

  //Team Revive
  "special_team-revive": {
    ...SuperActionModel,
    name: "Team Revive",
    category: "healing",
    description: "Raise all dead allies from the dead!",
    targetType: "ally-team",
    targetMustBeDead: true,
    affectTargetHpPointsByPercent: 0.45, //%

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        {
          type: "message",
          content: [
            `Allies revived!`,
          ]
        }
      ]
    },
  },

  //Commit
  "special_commit": {
    ...SuperActionModel,
    name: "Commit",
    description: "Save HP and PP of all combatants to Revert later.",
    targetType: "all",
    canMiss: false,
    changeCasterCommittedData: true,
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {

      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        //animation
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` committed the situation!`,
          ]
        }
      ]
    },
  },

  //Revert (available after COMMIT)
  "special_revert": {
    ...SuperActionModel,
    name: "Revert",
    description: "Reset all combatants to saved Commit.",
    targetType: "all",
    canMiss: false,
    useCasterCommittedData: true,
    canBeReplaced: false, //Can't be replaced when lagging, or whatever. The point of this is to bail you out from bad situations

    shouldFail: function (actionModel, casterModel, targetModels) {
      return (!casterModel.committedTurnData)
    },

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        //animation
        {
          type: "message",
          content: [
            `The battle is reverted to `,
            getColoredNameById(casterModel.id),
            `'s Commit!`,
          ]
        }
      ]
    }
  },

  //SQL Drop
  "special_sql-drop": {
    ...SuperActionModel,

    name: "SQL Drop",
    description: "Delete all enemy items.",

    targetType: "opponent-team",
    targetCanBeDead: true,
    ignoreTargetDieResult: true, //Don't show any "he died" messaging. He might already be dead, and this can't hurt ya.
    deleteItemQuantity: 50, //Banking that this is high enough to get all possible items. Don't want to bloat the loop too much

    shouldFail: function (actionModel, casterModel, targetModels, descriptionObject) {
      let targetTeamItems = targetModels.map(targetModel => {
        return targetModel.items
      }).reduce((a, b) => {
        return [...a, ...b]
      });
      return targetTeamItems.length === 0; //Return TRUE if this team has zero items.
    },

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, ""),
        //animation
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` deleted all enemy items!`,
          ]
        }
      ]
    },
  },


}


// WEBPACK FOOTER //
// ./src/battle/battle-data/_supers.js